'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.GET_MY_CHANNEL_FAILURE = exports.GET_MY_CHANNEL_COMPLETE = exports.GET_MY_CHANNEL_START = exports.GET_USER_IDENTITY_FAILURE = exports.GET_USER_IDENTITY_COMPLETE = exports.GET_USER_IDENTITY_START = undefined;
exports.getMeInfo = getMeInfo;
exports.getMyChannel = getMyChannel;

var _httpService = require('../../helpers/httpService');

var HTTP = _interopRequireWildcard(_httpService);

var _config = require('../../config');

var _logging = require('../lib/app/logging');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

// Action Types
var GET_USER_IDENTITY_START = exports.GET_USER_IDENTITY_START = 'GET_USER_IDENTITY_START';
var GET_USER_IDENTITY_COMPLETE = exports.GET_USER_IDENTITY_COMPLETE = 'GET_USER_IDENTITY_COMPLETE';
var GET_USER_IDENTITY_FAILURE = exports.GET_USER_IDENTITY_FAILURE = 'GET_USER_IDENTITY_FAILURE';
var GET_MY_CHANNEL_START = exports.GET_MY_CHANNEL_START = 'GET_MY_CHANNEL_START';
var GET_MY_CHANNEL_COMPLETE = exports.GET_MY_CHANNEL_COMPLETE = 'GET_MY_CHANNEL_COMPLETE';
var GET_MY_CHANNEL_FAILURE = exports.GET_MY_CHANNEL_FAILURE = 'GET_MY_CHANNEL_FAILURE';

// -------------------------------------------------------------- CONFIGURATION --------------------------------------------------------------

var configuration = void 0;
var config = function config() {
    return !configuration ? _config.Configuration.getConfig() : configuration;
};
var baseUrl = function baseUrl() {
    return config().service.baseUrl;
};
var identityServiceUrl = function identityServiceUrl() {
    return config().identityService.baseUrl;
};

function getHeader(state, authType) {
    var header = { 'Content-Type': 'application/json', Accept: 'application/json' };
    if (state && state.auth && state.auth.authInfo && state.auth.authInfo.access_token) {
        !authType ? header.Authorization = 'Token ' + state.auth.authInfo.access_token : header.Authorization = authType + ' ' + state.auth.authInfo.access_token;
    }
    return header;
}

// -------------------------------------------------------------- LOGGING --------------------------------------------------------------
var logger = void 0;
function loggingHelper(msg, attributes) {
    if (!logger) {
        logger = (0, _logging.appLogger)().create('action-identity-info');
    }
    logger.error(msg, attributes);
}

// -------------------------------------------------------------- READ --------------------------------------------------------------
function getMeInfo() {
    return function (dispatch, getState) {
        var reqUrl = identityServiceUrl() + '/identity/v1/Users/me';
        var store = getState();
        var header = getHeader(store, 'Bearer');

        dispatch({ type: GET_USER_IDENTITY_START });

        return HTTP.getData(reqUrl, header).then(function (identityInfo) {
            dispatch({ type: GET_USER_IDENTITY_COMPLETE, identityInfo: identityInfo });
        }).catch(function (err) {
            loggingHelper('failed to fetch user identity', { method: 'getMeInfo', error: err });
            dispatch({ type: GET_USER_IDENTITY_FAILURE, err: err });
        });
    };
}

function getMyChannel() {
    var reqUrl = baseUrl() + '/channels';

    return function (dispatch, getState) {
        var store = getState();
        var header = getHeader(store);

        dispatch({ type: GET_MY_CHANNEL_START });

        return HTTP.getData(reqUrl, header).then(function (channels) {
            dispatch({ type: GET_MY_CHANNEL_COMPLETE, channels: channels });
            return Promise.resolve(channels);
        }).catch(function (error) {
            loggingHelper('get channels fetch failed', { method: 'getMyChannel', callType: 'GET', error: error });
            dispatch({ type: GET_MY_CHANNEL_FAILURE, error: error });
            return Promise.reject(error);
        });
    };
}


//////////////////
// WEBPACK FOOTER
// ./~/@getgo/webinar.com-frontend-redux/lib/shared/actions/identity-info.js
// module id = 748
// module chunks = 0